import axios from "axios";
import React from "react";

import {loadDocumentsForPatientById, setDocuments} from "../store/reducers/documents";
import {loadPatientById, setPatient} from "../store/reducers/patient";


export const loadPatientWithDocuments = (patientId, patientObject, dispatch, t) => () => {
    if (!patientObject || patientObject.hospitalNumber !== patientId) {
        if (patientObject) {
            dispatch(setPatient(undefined));
            setDocuments({
                patientId: undefined,
                documents: undefined,
            })
        }

        dispatch(loadPatientById(patientId));
    } else if (patientObject.hospitalNumber === patientId) {
        // patient loaded - let's load documents (we may do this in parallel but in this case that looks rather bad)
        dispatch(loadDocumentsForPatientById(t, patientId));

        // TODO:
        // 1. Check studies
        // 2. Check orders (maybe there are some unfulfilled?)
        // 3. What if order is unfulfilled for some time? Max wait time need to be specified
        // 4. Should i show documents as well ? or only studies ?
        //
    }
};

/*
export const loadImage = (url) => {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                responseType: "arraybuffer",
            })
            .then(response => {
                const buffer = Buffer.from(response.data, "base64");
                resolve(buffer);
                // resolve(response.data);
            })
            .catch(ex => {
                // maybe we should load something anyway ?
                console.error(ex);
                reject(ex);
            });
    });
};
*/

export const loadImage = (url) => {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                responseType: "blob",
            })
            .then(response => {
                // const buffer = Buffer.from(response.data, "base64");
                // resolve(buffer);
                // resolve(response.data);
                const reader = new window.FileReader();
                reader.readAsDataURL(response.data);
                reader.onload = function() {
                    const imageData = reader.result;
                    // TODO: store in some cache ???
                    resolve(imageData);
                }
            })
            .catch(ex => {
                // maybe we should load something anyway ?
                console.error(ex);
                reject(ex);
            });
    });
};
